import React, { useRef, useEffect, Fragment } from 'react';
import { Transition } from 'components';
import { useToggle, useKey, useLockBodyScroll } from 'helpers';
import css from './video.scss';

export function Video(props) {
  const ref = useRef();
  const [ playing, togglePlaying ] = useToggle(false);

  useEffect(() => {
    if (ref.current && playing) {
      ref.current.play();
      ref.current.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } else if (ref.current) {
      ref.current.pause();
    }
  }, [ playing ]);

  useKey('Escape', () => {
    if (playing) {
      togglePlaying();
    }
  }, {}, [ playing ]);

  useLockBodyScroll(playing);

  return (
    <div className={css.video} onClick={togglePlaying} style={{ paddingBottom: (props.aspectRatio || 9/16)*100 + '%' }}>
      <Transition in={playing} mountOnEnter timeout={500} classNames={css.locals}>
        <div className={css.overlay} />
      </Transition>
      { /embed/.test(props.src)
        ? <iframe src={props.src} />
        : <Fragment>
          <video inline="true" preload="metadata" ref={ref} className={css({ playing })}>
            <source src={props.src} type="video/mp4" />
          </video>
          <svg className={css('play', { playing })} viewBox="0 0 100 100">
            <path d="M50 0c27.614 0 50 22.386 50 50s-22.386 50-50 50S0 77.614 0 50 22.386 0 50 0zM39.651 28.79a3 3 0 00-3 3v36.42a3 3 0 004.73 2.451l25.798-18.21a3 3 0 000-4.902L41.381 29.34a3 3 0 00-1.73-.55z" />
          </svg>
          <svg className={css('close', { playing })} viewBox="0 0 241.171 241.171">
            <path d="M138.138 120.754l99.118-98.576a11.931 11.931 0 000-17.011c-4.74-4.704-12.439-4.704-17.179 0l-99.033 98.492-99.949-99.96c-4.74-4.752-12.439-4.752-17.179 0-4.74 4.764-4.74 12.475 0 17.227l99.876 99.888L3.555 220.497c-4.74 4.704-4.74 12.319 0 17.011 4.74 4.704 12.439 4.704 17.179 0l100.152-99.599 99.551 99.563c4.74 4.752 12.439 4.752 17.179 0 4.74-4.764 4.74-12.475 0-17.227l-99.478-99.491z"/>
          </svg>
        </Fragment>
      }
    </div>
  );
}
